import React from 'react'
import {
    DateInput,
    Edit,
    SimpleForm,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    TextInput,
    SelectInput,
    BooleanInput,
    required,
    CheckboxGroupInput
    } from 'react-admin'
import withStyles from '@material-ui/core/styles/withStyles';
import InsNames from './InsNames';
import frequent from '../controls/Frequency'
import SanitizedTextInput from '../controls/SanitizedTextInput';

const styles = {
    th: {
        backgroundColor: "silver", 
        fontWeight: "bold", 
        height: "35px", 
        textAlign: "center"
    }
}

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const RegistrationActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label='List'/>
    </CardActions>
);

const TrainingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const editStyles = {
    root: { alignItems: 'flex-start'},

    inlineBlock: {
        display: 'inline-flex',
        marginRight: '8px',
    },
};

const EquipcategoryEdit=({classes, ...props }) => (
    
    <Edit 
        title='Instrument Edit' 
        {...props}  
        actions={<RegistrationActions />} 
        >
       <SimpleForm toolbar={<TrainingToolbar />}> 
       <table cellPadding={8} style={{width: '100%'}}>
           <tr>
               <th colSpan={4} className={classes.th}>Insrument Information</th>
           </tr>
           <tr>
                <td>Instrument Name:</td>
                <td><InsNames /> </td>
                <td>Instrument ID:</td>
                <td><SanitizedTextInput fullWidth source='ins_id' label = '' validate={required()}/> </td>
           </tr>
           <tr>
                <td>Alt Instrument ID 1:</td>
                <td><SanitizedTextInput fullWidth source='alt_id_1' label = '' /> </td>
                <td>Alt Instrument ID 2:</td>
                <td><SanitizedTextInput fullWidth source='alt_id_2' label = '' /> </td>
           </tr>
           <tr>
                <td>Manufacture:</td>
                <td><SanitizedTextInput fullWidth source='manufacture' label = '' /> </td>
                <td>Serial Number</td>
                <td><TextInput fullWidth source='serial_num' label = '' validate={required()}/> </td>
           </tr>
           <tr>
                <td>Make & Model:</td>
                <td><SanitizedTextInput fullWidth source='make_model' label = '' /> </td>
                <td>Size:</td>
                <td><SanitizedTextInput fullWidth source='ins_size' label = ''  /> </td>
           </tr>
           <tr>
                <td>Supplier:</td>
                <td><SanitizedTextInput fullWidth source='supplier' label = '' /> </td>
                <td colSpan={2}>&nbsp;</td>
           </tr>
           <tr>
                <td>Purchase Date:</td>
                <td><DateInput source='purchase_dt' label = '' locales="en-us" /> </td>
                <td>Expire Date:</td>
                <td><DateInput source='expire_dt' label = '' locales="en-us" /> </td>
           </tr>
           <tr>
                <td colSpan={2}>
                    <BooleanInput source="is_active" label='Is an Active Instrument?'  />
               </td>
               <td>Comments:</td>
                <td><TextInput fullWidth source='comments' label = ''  /> </td>
           </tr>
           <tr>
               <th colSpan={4}  className={classes.th}>Tasks</th>
           </tr>
           <tr>
               <td colSpan={4}>
                   <BooleanInput source='is_calibration' label='Calibration' />
                </td>
            </tr>
            <tr>
                <td>
                    Frequency:
                </td>
                <td colSpan={3}>
                    <CheckboxGroupInput  source="cal_frequency"    label="" choices={frequent}/>
                </td>
            </tr>
            <tr>
                <td colSpan={4}><hr /></td>
            </tr>
          
           <tr>
               <td colSpan={4}>
                   <BooleanInput source='is_maintenance' label='Maintenance' />
                </td>
            </tr>
            <tr>
                <td>
                    Frequency:
                </td>
                <td colSpan={3}>
                    <CheckboxGroupInput  source="main_frequency"    label="" choices={frequent}/>
                </td>
           </tr>
           <tr>
                <td colSpan={4}><hr /></td>
            </tr>
           <tr>
               <td colSpan={4}>
                   <BooleanInput source='is_validation' label='Validation' />
                </td>
            </tr>
            <tr>
                <td>
                    Frequency:
                </td>
                <td colSpan={3}>
                    <CheckboxGroupInput  source="val_frequency"    label="" choices={frequent}/>
                </td>
           </tr>
           <tr>
                <td colSpan={4}><hr /></td>
            </tr>
           <tr>
               <td colSpan={4}>
                   <BooleanInput source='is_log' label='Log' />
                </td>
            </tr>
            <tr>
                <td>
                    Frequency:
                </td>
                <td colSpan={3}>
                    <CheckboxGroupInput  source="log_frequency"    label="" choices={frequent}/>
                </td>
           </tr>
           <tr>
                <td colSpan={4}><hr /></td>
            </tr>
       </table>
       </SimpleForm>
    </Edit>
)

export default  withStyles(styles)(EquipcategoryEdit)